import React, { useState } from 'react';
import { toast } from 'sonner';
import { Star, Mail, CalendarPlus, UserX } from 'lucide-react';
import { Button } from '../ui/button';

export const BetaActions = ({ t, api, reload }) => {
  const [days, setDays] = useState(30);
  const name = t.application?.fullName || t.practiceName;
  const id = t.practiceId;
  const act = async (fn, ok, confirmText) => {
    if (confirmText && !window.confirm(confirmText)) return;
    try { await fn(); toast.success(ok); await reload(); } catch (e) { toast.error(e.response?.data?.detail || 'Something went wrong'); }
  };
  const done = t.status === 'removed';
  return (
    <div className="flex flex-wrap items-center gap-2">
      {t.status !== 'lifetime' && !done && (
        <Button size="sm" className="bg-amber-500 hover:bg-amber-600 text-white" data-testid={`beta-lifetime-btn-${id}`}
          onClick={() => act(() => api.lifetime(id), `${name} is now free for life`, `Make ${name} free for life? Only do this once you have their testimonial, photo and 5-star review.`)}>
          <Star className="w-4 h-4 mr-1" /> Grant Lifetime
        </Button>
      )}
      <span className="inline-flex items-center gap-1">
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="h-9 border border-slate-300 rounded-md px-2 text-sm" data-testid={`beta-extend-days-${id}`}>
          {[7, 14, 30, 60, 90].map((d) => <option key={d} value={d}>{d} days</option>)}
        </select>
        <Button size="sm" variant="outline" data-testid={`beta-extend-btn-${id}`} disabled={t.status === 'lifetime'}
          onClick={() => act(() => api.extend(id, days), `Beta extended by ${days} days`)}>
          <CalendarPlus className="w-4 h-4 mr-1" /> {done ? 'Restore +' : 'Extend'}
        </Button>
      </span>
      {!done && (
        <Button size="sm" variant="outline" data-testid={`beta-remind-btn-${id}`}
          onClick={() => act(() => api.remind(id), 'Testimonial request emailed', `Email ${name} now asking for their testimonial, photo and review?`)}>
          <Mail className="w-4 h-4 mr-1" /> Ask for testimonial
        </Button>
      )}
      {!done && (
        <Button size="sm" variant="outline" className="text-rose-700 hover:text-rose-800" data-testid={`beta-remove-btn-${id}`}
          onClick={() => act(() => api.remove(id), `${name} removed from the beta`,
            `Remove ${name} from the beta? Their free access ends now (they can still subscribe) and their spot opens up for someone else.`)}>
          <UserX className="w-4 h-4 mr-1" /> Remove from beta
        </Button>
      )}
    </div>
  );
};
